import React from "react";
import { formatCurrency } from "../../../../libs/utils";
import styles from "./ReceiptMultiInvoiceAllocation.module.scss";

type SummarySectionProps = {
  totalAllocated: number;
  overpaymentCredit: number;
  hasSelectedInvoices?: boolean;
  applyOverpaymentCredit?: boolean;
};

export const SummarySection: React.FC<SummarySectionProps> = ({
  totalAllocated,
  overpaymentCredit,
  hasSelectedInvoices = true,
  applyOverpaymentCredit = false,
}) => (
  <div className={styles.summarySection}>
    <p className={styles.summaryRow}>
      <span className={styles.summaryLabel}>
        {applyOverpaymentCredit ? "Total Applied from Credit" : "Total Allocated"}
      </span>
      <strong className={styles.summaryAmount}>{formatCurrency(totalAllocated)}</strong>
    </p>
    {hasSelectedInvoices && overpaymentCredit > 0 && (
      <p className={styles.summaryRow}>
        <span className={styles.summaryLabel}>
          {applyOverpaymentCredit ? "Remaining Credit" : "+ Overpayment Credit"}
        </span>
        <strong className={styles.summaryAmountSecondary}>{formatCurrency(overpaymentCredit)}</strong>
      </p>
    )}
  </div>
);
